/**
 * Shared preview/print semantics for nonprinting authoring controls.
 * Every rule must hold: the answer `equals` one choice, or is `oneOf` a list.
 */
export function authoringVisibility(transform:Record<string,unknown> | undefined,values:Record<string,unknown>):boolean|undefined {
 const rules=transform?.authoringVisibility;
 if(!Array.isArray(rules)) return undefined;
 return rules.length>0 && rules.every(rule=>{
  if(!rule || typeof rule.optionId!=='string') return false;
  const answer=values[rule.optionId];
  if(typeof rule.equals==='string') return answer===rule.equals;
  return Array.isArray(rule.oneOf) && rule.oneOf.length>0 && typeof answer==='string' && rule.oneOf.includes(answer);
 });
}
